import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '../../app.constants';
import { BaseMiscApiService } from 'src/app/_common/api/base-misc-api.service';
import { HostHistoricalApi } from './models/historical';
import { PrtgConstants } from '../prtg-constants';
import { DatesService, MediaTypes } from 'src/app/_common/services';
import { RangeKey } from 'src/app/_common/enum';
import { HostsFilter } from '../models';

@Injectable({
    providedIn: 'root'
})
export class HostMiscApiService extends BaseMiscApiService {
    constructor(
        private datesService: DatesService,
        http: HttpClient) {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlPrtg;
        this.segmentApi = '/prtg/hosts';
    }

    getHosts(page: number = 1, limit: number = 100): Observable<any> {
        if (AppConstants.IsDataLocal('prtg')) {
            return this.http.get<any>('assets/data/prtg/hosts.json');
        }

        return this.get<any>(`/hosts?page=${page}&limit=${limit}`);
    }

    getHostHistory(hostId: string): Observable<HostHistoricalApi> {
        const last24 = this.datesService.preRangeDates(RangeKey.LAST24HOURS);
        const rawRange = this.datesService.RawUtcDateRange(last24.since, last24.until);

        if (AppConstants.IsDataLocal('prtg')) {
            return this.http.get<any>(`assets/data/prtg/SEB/${hostId}.json`);
        }

        return this.get<any>(`/history?hostId=${hostId}&averageSecs=${PrtgConstants.AverageSecs}&${rawRange}`);
    }

    export(hostsFilter: HostsFilter, format: MediaTypes): Observable<HttpEvent<Blob>> {
        return this.download('/export', format, { statuses: hostsFilter.statuses, types: hostsFilter.types });
    }
}
